import {
	createTurnAction,
	createStateCondition,
	createStateChangedTrigger,
} from '../../common/stateManagement.js';
import { createPowerLevelCondition, createPowerThresholdTrigger } from '../../common/powerMonitoring.js';

/**
 * Quad Relay Template (Gen2+ RPC API)
 * Supports devices with 4 independent relay channels
 * Uses Switch.Set RPC method for control
 */
export function createQuadRelayTemplate() {
	return {
		deviceType: 'quad_relay',
		channels: ['switch:0', 'switch:1', 'switch:2', 'switch:3'],
		actions: {
			turn: createTurnAction('Switch.Set', 'on'),
		},
		conditions: {
			isOn: createStateCondition('output'),
		},
		triggers: {
			stateChanged: createStateChangedTrigger('output'),
		},
	};
}

/**
 * Quad Relay with Power Monitoring Template (Gen2+ RPC API)
 * Adds power monitoring capabilities to quad-relay template
 */
export function createQuadRelayPMTemplate() {
	return {
		deviceType: 'quad_relay_pm',
		channels: ['switch:0', 'switch:1', 'switch:2', 'switch:3'],
		actions: {
			turn: createTurnAction('Switch.Set', 'on'),
		},
		conditions: {
			isOn: createStateCondition('output'),
			powerLevel: createPowerLevelCondition(3680),
		},
		triggers: {
			stateChanged: createStateChangedTrigger('output'),
			powerThreshold: createPowerThresholdTrigger(),
		},
	};
}
